export const PRIVACY_SETTINGS_FEATURES = {
  TRAINING_DATA: 'trainingDataEnabled',
  EXTERNAL_LLM: 'externalLlmEnabled',
  EXTERNAL_LANGUAGE_TRANSLATION: 'externalLanguageTranslationEnabled',
  EXTERNAL_PLAGIARISM_DETECTION: 'externalPlagiarismDetectionEnabled',
  EXTERNAL_WEB_SEARCH: 'externalWebSearchEnabled',
};
